/**
 * Format a string with underscores/hyphens into proper title case display
 * "public_speaking" → "Public Speaking"
 * "business-management" → "Business Management"
 */
export const formatDisplayName = (str) => {
  if (!str) return '';
  return str
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
};
